const en_US = {
    rules: {
        title: "Rules",
        content1: `Players can enter Midafi Staking to mine with Midafi pledge. The Midafi mine has a total reserve of 1.155 million pieces, accounting for 55% of the total circulation of Midafi, and the mining period is 100 years. 
 
Contract rules: 
1. Midafi pledged mining can be taken as it is pledged, and mining can be extracted at any time. 
 
2. When pledging Midafi, there must be a certain amount of energy ratio of Sero at the same time. The pledgor shall be regarded as an effective pledge, and the settlement shall be made at 12 noon every day. Sero shall be consumed according to the ratio of Midafi: Sero (10: 1) during settlement. 
 
3. Midafi pledges the MPM contract of mining computing power linkage, and MPM players have computing power bonus when participating in mining. 
(1) The computing power of mining participants pledged by Midafi alone is 100%; 
(2) If the total number of MPM players participating in Sero is 10 ~ 4999, the computing power value is 110%; 
(3) If MPM players participate in Sero with a total number of 5000 ~ 9999, the computing power value is 120%; 
(4) If the total number of MPM players participating in Sero is 10,000-49,999, the computing power value is 130%; 
(5) If MPM players participate in Sero with a total number of 50,000 ~ 99,999, the computing power value is 140%; 
(6) The total number of MPM players participating in Sero is over 100,000, and the computing power value is 150%. 
 
4. The energy distribution of Sero consumed by mining Midafi is as follows: 
50% MPM linkage 100-year dividend 
20% community construction 
20% repurchase Midafi destruction 
5% R&D center 
5% Technology Center 
 
5. MPM linkage 100-year dividend is a welfare to pay tribute to MPM players. MPM players who participate in pledge mining can participate in 100-year dividend according to their MPM account linkage. Participants must pledge Midafi according to the total participation amount of MPM linkage account Sero at a ratio of 100: 1 (total participation amount: pledge amount) before obtaining Sero 100-year dividends. Free participation, no damage to dividends, and take as you go. 
Example: 
MPM Sero has a total participation of 10,000, and the maximum pledge is 100MIDAFI to participate in dividends 
 
Dividends are settled at 12 noon every day. Dividends are evenly distributed according to the weight of pledged MIDAFI quantity. 
 
6. Community construction is organized and autonomous by Midafi Dao, and participating players can enter the Midafi Dao section. 
 
7. Open source system code, data uplink, decentralized bookkeeping, no back door, no tampering, automatic operation and automatic distribution. 
 
8. The system discloses the contract rules. Players can take the initiative to participate without a recommender. 
 
9. Source address: GitHub page: `,
        content2: `

Gitee page: `,
        content3: `

Netlify page: `,
        content4: `
10. Address: `,
    },
    language: "Language",
    wallet: "Wallet",
    changeToWallet: "Switch to ",
    changeToLang: "切換到 ",
    tip: {
        addrCopied: 'Address Copied',
    },
    text: {
        staking: 'Staking',
        gas: 'Gas',
        apy: 'APY',
        computingPower: 'Power',
        centennialDividend: 'Centennial Dividend',
    },
    input: {
        prompt1: 'MPM Total Investment',
        prompt2: 'Centennial Quota',
        prompt3: 'Used Quota',
        prompt4: 'Left Quota',
        promptWithdrawInterest: 'Interest Amount (Unit: MIDAFI)',
        promptReinvest: 'Interest Amount (Unit: MIDAFI)',
        promptDepositMidafi: 'Please Input Amount (Unit: MIDAFI)',
        promptWithdrawSero: 'Please Input Amount (Unit: SERO)',
    },
    button: {
        ok: 'OK',
    },
    imageLocation: 'en',
    riskWarning: 'Venture capital, cautious participation.',
    changeWallet: {
        title: 'Change Account',
        content: 'Are you sure?',
        ok: 'YES'
    },
}

export default en_US;